import { render, staticRenderFns } from "./orderMsg.vue?vue&type=template&id=5714994e&scoped=true&"
import script from "./orderMsg.vue?vue&type=script&lang=js&"
export * from "./orderMsg.vue?vue&type=script&lang=js&"
import style0 from "./orderMsg.vue?vue&type=style&index=0&id=5714994e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5714994e",
  null
  
)

export default component.exports